import {HttpParams} from '@angular/common/http';

interface SpringSort {
  column: string;
  direction: 'desc' | 'asc';
}

export class SpringPageable {
  page = 0;
  size: number;
  sort: Array<SpringSort>;

  toHttpParams(): HttpParams {
    let params = new HttpParams();
    params = params.append('page', String(this.page));
    params = params.append('size', String(this.size));
    for (const sort1 of this.sort)
      params = params.append('sort', `${sort1.column},${sort1.direction}`);
    return params;
  }

  setSort(sort: SpringSort) {
    this.sort = [sort];
  }
}
